import './App.css';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import eyeOutlinedSvg from './assets/eye-outline.svg';

function App() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const kind = ['chat', 'post', 'eventCheckIn', 'event'].find(key => params.get(key));
  const id = kind ? params.get(kind) : '';
  const [result, setResult] = useState({ state: 'loading' });

  useEffect(() => {
    if (!id) {
      setResult({ state: 'error', message: 'Ссылка не содержит идентификатор.' });
      return;
    }
    const controller = new AbortController();
    setResult({ state: 'loading' });
    fetch(`/${kind === 'chat' ? 'room' : 'post'}/${encodeURIComponent(id)}`, { signal: controller.signal })
      .then(async response => {
        if (!response.ok) throw new Error(response.status === 404 ? 'Публикация не найдена.' : 'Не удалось загрузить публикацию.');
        const body = await response.json();
        if (body.status === 204) throw new Error('Тотем не найден.');
        // The room API wraps data; the post API returns the document directly.
        const data = kind === 'chat' ? body.data : body;
        if (!data?._id) throw new Error('Публикация не найдена.');
        setResult({ state: 'ready', data });
      })
      .catch(error => {
        if (error.name !== 'AbortError') setResult({ state: 'error', message: error.message });
      });
    return () => controller.abort();
  }, [id, kind]);

  const data = result.data;
  const date = data?.eventMetadata?.startDate ? new Date(data.eventMetadata.startDate) : null;
  const imageId = data?.content?.media?.images?.[0];
  const imageUrl = kind === 'chat' ? `/image/${encodeURIComponent(id)}` : imageId ? `/media/${encodeURIComponent(imageId)}` : null;

  return (
    <div className="app">
      <main className="main">
        <div className="totem" aria-live="polite">
          {result.state === 'loading' && <p role="status">Загрузка…</p>}
          {result.state === 'error' && <p role="alert">{result.message}</p>}
          {data && <>
            {imageUrl && <img className={`totem__image ${kind === 'chat' ? 'totem__image-round' : ''}`} src={imageUrl} alt={data.fname || 'Totem Chat'} />}
            <h1 className="totem__title">{data.fname || data.name || data.eventMetadata?.title || 'Totem Chat'}</h1>
            {data.content?.text && <p>{data.content.text}</p>}
            <div className="totem__fields">
              {data.customFields?.category?.nameRu && <p className="totem__field">{data.customFields.category.nameRu}</p>}
              {kind === 'chat' && <p className="totem__field">{data.usersCount ?? 0} участников</p>}
              {date && !Number.isNaN(date.getTime()) && <p className="totem__field">{date.toLocaleDateString('ru-RU')}</p>}
              {kind !== 'chat' && <p className="totem__field"><img className="icon" src={eyeOutlinedSvg} alt="Просмотры" />{data.viewsCount ?? 0}</p>}
            </div>
            <a className="go-to-app-button go-to-app-link" href={`https://thetotemchat.com/share${location.search}`} target="_blank" rel="noreferrer">Посмотреть в Totem Chat</a>
          </>}
        </div>
      </main>
    </div>
  );
}

export default App;
